/* eslint-disable react/jsx-key */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable nordic/no-img-tags */
/* eslint-disable react/prop-types */
const React = require('react');
const ChevronRight16 = require('@andes/icons/ChevronRight16');

const SmartGroupCard = ({ smartGroups, offset, cardsPerRow = 1, smartGroupLinkText }) => {
  const smartGroupClassName = 'smart-group';
  const cardsToDisplay = smartGroups?.slice(offset, offset + cardsPerRow);

  const renderCards = () => {
    return cardsToDisplay?.map((card, index) => {
      const images = Array.isArray(card.images) ? card.images.slice(0, 4) : [];
      // const imageLinks = Array.isArray(card.imageLinks) ? card.imageLinks.slice(0, 4) : [];

      return (
        <div key={index} className={smartGroupClassName}>
          <a href={card.link} className={`${smartGroupClassName}__link-card`}>
            <div className={`${smartGroupClassName}__content`}>
              <h3 className={`${smartGroupClassName}__title`}>{card.title}</h3>
              <p className={`${smartGroupClassName}__subtitle`}>{card.subtitle}</p>
            </div>
            <div className={`${smartGroupClassName}__images`}>
              {images.map((image, imgIndex) => (
                // <a
                //   key={imgIndex}
                //   href={imageLinks[imgIndex] || 'https://dev.mercadolivre.com.br:8443/ofertas'}
                //   className={`${smartGroupClassName}__image-link`}
                // >
                <img
                  src={image}
                  alt={`${card.title} - image ${imgIndex + 1}`}
                  className={`${smartGroupClassName}__image`}
                />
                // </a>
              ))}
            </div>
            <div className={`${smartGroupClassName}__footer`}>
              <div className={`${smartGroupClassName}__link`}>
                <b>{smartGroupLinkText}</b>
                <ChevronRight16 color="rgb(52, 131, 250)" />
              </div>
            </div>
          </a>
        </div>
      );
    });
  };

  return <div className={`${smartGroupClassName}__list`}>{renderCards()}</div>;
};

module.exports = SmartGroupCard;
